import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiErrorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(pathOrUrl, opts = {}) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http") || pathOrUrl.startsWith("data:") || pathOrUrl.startsWith("blob:")) {
    return pathOrUrl;
  }
  const q = opts.variant === "thumb" ? "?variant=thumb" : "";
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}${q}`;
  return `${BACKEND_URL}/api/files/${pathOrUrl}${q}`;
}

// Small gallery/card variant — falls back to the full image if a thumb isn't
// available (e.g. pre-migration uploads).
export function thumbUrl(pathOrUrl) {
  return fileUrl(pathOrUrl, { variant: "thumb" });
}
